import { createAsyncThunk } from '@reduxjs/toolkit';
import { gatewayRequestAxios } from '../../services/interceptor';

import { GATEWAY_API_REVIEWS_URL, GATEWAY_API_CAMPIAGN_URL } from '../../constants/urls';

export const fetchOpenCampiagn = createAsyncThunk('reviews/fetchOpenCampiagn', async () => {
    const response = await gatewayRequestAxios.get(`${GATEWAY_API_CAMPIAGN_URL}`, {
        params: {
            filter: 'status eq "ACTIVE"',
            limit: 200,
        }
    })
    return response.data
})

export const fetchClosedCampiagn = createAsyncThunk('reviews/fetchClosedCampiagn', async () => {
    const response = await gatewayRequestAxios.get(`${GATEWAY_API_CAMPIAGN_URL}`, {
        params: {
            filter: 'status eq "COMPLETED"',
            limit: 200
        }
    })
    return response.data
})

export const fetchReviews = createAsyncThunk('reviews/fetchReview', async (id) => {
    const response = await gatewayRequestAxios.get(`${GATEWAY_API_REVIEWS_URL}`, {
        params: {
            filter: `reviewerId eq "${id}"`,
            limit: 200,
            orderBy: 'created desc'
        }
    })

    return response.data
})
